/**
 * Arquivo da carga inicial do Tecprog (ADR 0012), gerado por
 * `tools/tecprog/carga.py` e lido pelo importador de `packages/db`.
 * O arquivo fica fora do repositório (dados do cliente); este schema é o
 * contrato entre os dois lados.
 */
import { z } from 'zod';
export const etapaCargaSchema = z.object({
    ordem: z.int().positive(),
    /** Nome do setor no OP (o importador resolve para o id). */
    setor: z.string().trim().min(1),
    nome: z.string().trim().min(1).max(200),
    /** Pode ser 0: etapa sem tempo, a cronometrar. */
    tempoUnitarioSeg: z.number().nonnegative(),
    /** "erp", "estimado pela produção", "mediana do estágio no ERP", "sem tempo". */
    origemTempo: z.string().trim().min(1),
});
export const produtoCargaSchema = z.object({
    codigo: z.string().trim().min(1).max(40),
    nome: z.string().trim().min(1).max(200),
    /** Nome da linha no OP (Tapete, Volante, Apoio). */
    linha: z.string().trim().min(1),
    tamanhoLote: z.int().positive(),
    multiploCaixa: z.int().positive().nullable(),
    ativo: z.boolean(),
    etapas: z.array(etapaCargaSchema).min(1),
});
export const operadorCargaSchema = z.object({
    nome: z.string().trim().min(1).max(120),
    /** "YYYY-MM-DD" */
    admitidoEm: z.iso.date(),
    /** Nome do turno no OP. */
    turno: z.string().trim().min(1),
    codigoErp: z.int().positive(),
});
export const cargaTecprogSchema = z.object({
    fonte: z.string(),
    geradoEm: z.string(),
    produtos: z.array(produtoCargaSchema),
    operadores: z.array(operadorCargaSchema),
});
//# sourceMappingURL=carga-tecprog.js.map